import { useCallback } from 'react';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useCurrentUser } from '@/hooks/useCurrentUser';

/**
 * Tracks the timestamp (unix seconds) at which the user last read the newsletter
 * mailbox. Any issue published after this is "unread" and contributes to the
 * News badge. Stored per-pubkey so switching accounts keeps independent state.
 */
export function useNewsletterRead() {
  const { user } = useCurrentUser();
  const key = user ? `newsletter-last-read:${user.pubkey}` : 'newsletter-last-read:anon';
  const [lastRead, setLastRead] = useLocalStorage<number>(key, 0);

  const markNewsletterRead = useCallback(() => {
    setLastRead(Math.floor(Date.now() / 1000));
  }, [setLastRead]);

  return { lastRead, markNewsletterRead };
}
